import { createContext } from "react";

export interface ProjectContextState {
  projectId: string;
}

export const ProjectContext = createContext<ProjectContextState>({
  projectId: "",
});
